import { PaymentProvider } from "../../models/Tenant";

export const REQUEST_PAYMENT_PROVIDER = "REQUEST_PAYMENT_PROVIDER";

export interface FetchPaymentProvider {
  type: typeof REQUEST_PAYMENT_PROVIDER;
  payload: ReadonlyArray<PaymentProvider>;
}

export type PaymentProviderActionTypes = FetchPaymentProvider;

export interface PaymentProviderState {
  paymentProviders: ReadonlyArray<PaymentProvider>;
}
